module.exports = __webpack_public_path__ + "img/2023-03.8681af90.jpg";